// removed by extract-text-webpack-plugin
module.exports = {"list":"_2XYyv-3haOjM0R0IT5UiTq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendRecipients.scss
// module id = 1305
// module chunks = 1